module.exports = __webpack_public_path__ + "img/team-mobile-6.15fa030e.jpg";